import { render, staticRenderFns } from "./QuestionTermsAndConditions.vue?vue&type=template&id=18688b9c&scoped=true&"
import script from "./QuestionTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./QuestionTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTermsAndConditions.vue?vue&type=style&index=0&id=18688b9c&scoped=true&lang=css&"
import style1 from "./QuestionTermsAndConditions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18688b9c",
  null
  
)

export default component.exports